import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Avatar } from "@mui/material";
import {
  HiBookOpen,
  HiDocumentText,
  HiEnvelope,
  HiInformationCircle,
  HiLockClosed,
  HiShieldCheck,
  HiSquares2X2,
  HiXMark,
  HiArrowRightOnRectangle,
  HiUserCircle,
  HiBriefcase,
} from "react-icons/hi2";

const NAV_GROUPS = [
  {
    title: "Explore",
    items: [
      { label: "Categories", to: "/categories", icon: HiSquares2X2 },
      { label: "Learn", to: "/learn", icon: HiBookOpen },
    ],
  },
  {
    title: "Legal",
    items: [
      {
        label: "Terms And Conditions",
        to: "/terms-and-conditions",
        icon: HiDocumentText,
      },
      { label: "Manage Cookies", action: "cookies", icon: HiShieldCheck },
      { label: "Privacy Policy", to: "/privacy-policy", icon: HiLockClosed },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "About Us", to: "/about-us", icon: HiInformationCircle },
      {
        label: "Become A Seller",
        to: "/become-a-seller",
        icon: HiBriefcase,
      },
      {
        label: "Contact",
        href: "mailto:contact@mockee.io",
        icon: HiEnvelope,
      },
    ],
  },
];

const SiteMobileNavDrawer = ({
  onClose,
  isLoggedIn,
  userType,
  profiledata,
  onLogout,
  onCookieSettings,
  onLogin,
}) => {
  const handleItemClick = (item) => {
    if (item.action === "cookies") {
      onCookieSettings();
    }
    onClose();
  };

  const dashboardLink =
    userType === "S"
      ? "/seller/dashboard"
      : userType === "F"
        ? "/affiliate/dashboard"
        : "/user/dashboard";
  const dashboardLabel =
    userType === "S"
      ? "Seller Dashboard"
      : userType === "F"
        ? "Affiliate Dashboard"
        : "My Account";

  return (
    <div className="site-mobile-nav">
      <div className="site-mobile-nav__header">
        <div className="site-mobile-nav__brand">
          <img
            src="/assets/images/justLogo.svg"
            alt="Mockee"
            className="site-mobile-nav__logo"
          />
          <div>
            <p className="site-mobile-nav__eyebrow mb-0">Mockee</p>
            <h2 className="site-mobile-nav__title mb-0">Menu</h2>
          </div>
        </div>
        <button
          type="button"
          className="site-mobile-nav__close"
          onClick={onClose}
          aria-label="Close menu"
        >
          <HiXMark size={22} />
        </button>
      </div>

      {isLoggedIn && (
        <Link
          to={dashboardLink}
          className="site-mobile-nav__account-card"
          onClick={onClose}
        >
          <Avatar
            src={profiledata?.profile || "/assets/images/user_vector.svg"}
            alt={profiledata?.full_name || "User"}
            sx={{ width: 44, height: 44 }}
          />
          <div className="site-mobile-nav__account-text min-w-0">
            <p className="site-mobile-nav__account-name mb-0 text-truncate">
              {profiledata?.full_name || "Your account"}
            </p>
            <p className="site-mobile-nav__account-link mb-0">
              Open {dashboardLabel}
            </p>
          </div>
          <HiUserCircle size={22} className="site-mobile-nav__account-icon" />
        </Link>
      )}

      <div className="site-mobile-nav__body">
        {NAV_GROUPS.map((group) => (
          <section key={group.title} className="site-mobile-nav__group">
            <p className="site-mobile-nav__group-title">{group.title}</p>
            <div className="site-mobile-nav__links">
              {group.items.map((item) => {
                const Icon = item.icon;
                const content = (
                  <>
                    <span className="site-mobile-nav__link-icon">
                      <Icon size={18} />
                    </span>
                    <span className="site-mobile-nav__link-label">
                      {item.label}
                    </span>
                  </>
                );

                if (item.to) {
                  return (
                    <Link
                      key={item.label}
                      to={item.to}
                      className="site-mobile-nav__link"
                      onClick={() => handleItemClick(item)}
                    >
                      {content}
                    </Link>
                  );
                }

                if (item.href) {
                  return (
                    <a
                      key={item.label}
                      href={item.href}
                      className="site-mobile-nav__link"
                      onClick={onClose}
                    >
                      {content}
                    </a>
                  );
                }

                return (
                  <button
                    key={item.label}
                    type="button"
                    className="site-mobile-nav__link site-mobile-nav__link--button"
                    onClick={() => handleItemClick(item)}
                  >
                    {content}
                  </button>
                );
              })}
            </div>
          </section>
        ))}
      </div>

      <div className="site-mobile-nav__footer">
        {isLoggedIn ? (
          <button
            type="button"
            className="site-mobile-nav__logout"
            onClick={() => {
              onLogout();
              onClose();
            }}
          >
            <HiArrowRightOnRectangle size={20} />
            Log out
          </button>
        ) : (
          <button
            type="button"
            className="site-mobile-nav__login"
            onClick={() => {
              onLogin();
              onClose();
            }}
          >
            Log in
          </button>
        )}
      </div>
    </div>
  );
};

SiteMobileNavDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  userType: PropTypes.string,
  profiledata: PropTypes.object,
  onLogout: PropTypes.func.isRequired,
  onCookieSettings: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
};

export default SiteMobileNavDrawer;
